<aims-side-menu [component]="permissions.ComponentID.HumanResources">
  <ng-template>
    <aims-side-menu-link [route]="'./'"
                         [component]="permissions.ComponentID.HumanResourcesDashboard"
                         [iconClass]="'fas fa-tachometer-alt'">
      HR Self Service Dashboard
    </aims-side-menu-link>
    <aims-side-menu-link [route]="'./hrConfig'"
                         [component]="permissions.ComponentID.HumanResourcesConfig"
                         [iconClass]="'fas fa-cog'">
      HR Config
    </aims-side-menu-link>

    <aims-side-menu-header [component]="permissions.ComponentID.HumanResources"
                           [displayText]="'Employees'"
                           [collapsible]="true">
      <aims-side-menu-link [route]="'./viewEmployees'"
                           [permission]="'Update'"
                           [component]="permissions.ComponentID.ViewEmployees"
                           [iconClass]="'fas fa-search'">
        View Employees
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./employee'"
                           [permission]="'Create'"
                           [component]="permissions.ComponentID.Employee"
                           [iconClass]="'fas fa-plus'">
        Create New Employee
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./reporting'"
                           [component]="permissions.ComponentID.Reporting"
                           [iconClass]="'fas fa-chart-area'">
        Reporting
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscGenerateFiscalPay'"
                           [component]="permissions.ComponentID.PscGenerateFiscalPay"
                           [iconClass]="'fas fa-plus'">
        Generate Fiscal Pay PSCs
      </aims-side-menu-link>

    </aims-side-menu-header>
    <aims-side-menu-header [component]="[permissions.ComponentID.PscHrRoutingQueue,
                              permissions.ComponentID.PscWsLeadReviewQueue,
                              permissions.ComponentID.PscDmApprovalQueue,
                              permissions.ComponentID.PscHrmApprovalQueue,
                              permissions.ComponentID.PscPmmApprovalQueue,
                              permissions.ComponentID.PscAcctReceivalQueue,
                              permissions.ComponentID.PscItReceivalQueue]"
                           [displayText]="'PSC Queues'"
                           [collapsible]="true">
      <aims-side-menu-link [route]="'./pscHrRouting'"
                           [component]="permissions.ComponentID.PscHrRoutingQueue"
                           [iconClass]="'fas fa-binoculars'">
        HR ({{ (hrCounts | async)?.hrRoutingCount }})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscHrAccepted'"
                           [component]="permissions.ComponentID.PscHrAcceptedQueue">
        <span style="padding: 0 10px">--</span>Accepted
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscHrRejected'"
                           [component]="permissions.ComponentID.PscHrRejectedQueue">
        <span style="padding: 0 10px">--</span>Rejected
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscWsLeadReview'"
                           [component]="permissions.ComponentID.PscWsLeadReviewQueue"
                           [iconClass]="'fas fa-binoculars'">
        WS Lead Review ({{(hrCounts | async)?.myWsLeadCount}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscDmApproval'"
                           [component]="permissions.ComponentID.PscDmApprovalQueue"
                           [iconClass]="'fas fa-binoculars'">
        Dept Mgr Approval ({{dmCountString | async}})
        <!--{{"("+(hrCounts | async)?.myDmApproveCount +")"+((permissions.canRead(permissions.ComponentID.PscPmmApprovalQueue))?"/("+(hrCounts | async)?.allDmApproveCount +")" :"")}}-->
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscHrmApproval'"
                           [component]="permissions.ComponentID.PscHrmApprovalQueue"
                           [iconClass]="'fas fa-binoculars'">
        HR Mgr Approval ({{(hrCounts | async)?.hrmApproveCount}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscHrmAccepted'"
                           [component]="permissions.ComponentID.PscHrmAcceptedQueue">
        <span style="padding: 0 10px">--</span>Accepted
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscHrmRejected'"
                           [component]="permissions.ComponentID.PscHrmRejectedQueue">
        <span style="padding: 0 10px">--</span>Rejected
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscPmmApproval'"
                           [component]="permissions.ComponentID.PscPmmApprovalQueue"
                           [iconClass]="'fas fa-binoculars'">
        PM Mgr Approval ({{(hrCounts | async)?.pmmApproveCount}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscAcctReceival'"
                           [component]="permissions.ComponentID.PscAcctReceivalQueue"
                           [iconClass]="'fas fa-binoculars'">
        Accounting Receival ({{(hrCounts | async)?.acctReceivalCount}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscAcctReceived'"
                           [component]="permissions.ComponentID.PscAcctReceivedQueue">
        <span style="padding: 0 10px">--</span>Received
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./pscItReceival'"
                           [component]="permissions.ComponentID.PscItReceivalQueue"
                           [iconClass]="'fas fa-binoculars'">
        IT Receival ({{(hrCounts | async)?.itReceivalCount}})
      </aims-side-menu-link>
    </aims-side-menu-header>
    <aims-side-menu-header [component]="permissions.ComponentID.MyTraining"
                           [displayText]="'Training'"
                           [collapsible]="true">
      <aims-side-menu-link [route]="'./trainingConfig'"
                           [component]="permissions.ComponentID.TrainingConfig"
                           [iconClass]="'fas fa-cog'">
        Training Config
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./myTraining'"
                           [component]="permissions.ComponentID.MyTraining"
                           [iconClass]="'fas fa-address-card'">
        My Training
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./employeeTraining'"
                           [component]="permissions.ComponentID.EmployeeTraining"
                           [iconClass]="'fas fa-binoculars fa-fw'">
        Employee Training
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./reportingTraining'"
                           [component]="permissions.ComponentID.ReportingTraining"
                           [iconClass]="'fas fa-chart-area'">
        Reporting
      </aims-side-menu-link>
    </aims-side-menu-header>
    <aims-side-menu-header [component]="[permissions.ComponentID.SelfTrainedCert,
                            permissions.ComponentID.TrainerCert,
                            permissions.ComponentID.QualApproval]"
                           [displayText]="'Training Queues'"
                           [collapsible]="true">

      <aims-side-menu-link [route]="'./selfTrainedCert'"
                           [component]="permissions.ComponentID.SelfTrainedCert"
                           [iconClass]="'fas fa-thumbs-up'">
        Self-Trained Cert  ({{(trCounts | async)?.myWsSelfTrainedCert}})/({{(trCounts | async)?.myDeptSelfTrainedCert}})/({{(trCounts | async)?.selfTrainedCert}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./trainerCert'"
                           [component]="permissions.ComponentID.TrainerCert"
                           [iconClass]="'fas fa-thumbs-up'">
        Trainer Cert  ({{(trCounts | async)?.myTrainerCert}})/({{(trCounts | async)?.myDeptTrainerCert}})/({{(trCounts | async)?.trainerCert}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./qualApproval'"
                           [component]="permissions.ComponentID.QualApproval"
                           [iconClass]="'fas fa-thumbs-up'">
        Qual Approval  ({{(trCounts | async)?.myQualApproval}})/({{(trCounts | async)?.myDeptQualApproval}})/({{(trCounts | async)?.qualApproval}})



      </aims-side-menu-link>


    </aims-side-menu-header>
  </ng-template>
</aims-side-menu>
